var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1.23057 18.7449C2.87131 20.4175 5.54116 20.4192 7.18269 18.7449L16.7055 9.03779C17.1839 8.55512 17.4486 7.90737 17.4502 7.21768C17.4543 5.83922 16.2715 4.6342 14.9193 4.63758C14.2429 4.63924 13.6082 4.90911 13.1315 5.40015L4.80134 13.8913C4.47254 14.2274 4.47254 14.7695 4.80134 15.1047C5.13013 15.4399 5.66279 15.4399 5.99159 15.1047L14.3242 6.61016C14.4861 6.44423 14.6974 6.35456 14.9235 6.35375C15.3739 6.35375 15.7668 6.75432 15.7668 7.2135C15.766 7.44395 15.678 7.65933 15.5178 7.82102L5.99159 17.5315C5.00766 18.5371 3.40559 18.5371 2.42083 17.5315C1.43606 16.5293 1.43606 14.8952 2.42083 13.8913L13.134 2.97C14.7747 1.29737 17.4453 1.29737 19.0861 2.97C20.7268 4.64262 20.7268 7.36517 19.0861 9.03779L10.7534 17.5315C10.4246 17.8667 10.4246 18.4097 10.7534 18.7449C11.0822 19.0801 11.6149 19.0801 11.9436 18.7449L20.2763 10.2512C22.5738 7.90903 22.5738 4.098 20.2763 1.75661C17.9796 -0.585536 14.2411 -0.585536 11.9436 1.75661L1.23057 12.678C-0.411005 14.3514 -0.411005 17.0723 1.23057 18.7449Z",
    fill: "#292F4C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClip);
export default __webpack_public_path__ + "static/media/clip.b435a22697026986f27f1a4779368e67.svg";
export { ForwardRef as ReactComponent };